import { ref, reactive, watch, Ref } from 'vue'
import md5 from 'js-md5'
import { Book } from '@/models'
import { useBookStore } from '@/stores'
import { swalError } from '@/utils'

export function useLock(book: Ref<Book>) {
  const bookStore = useBookStore()

  /**
   * パスワードが設定されているか否か
   *
   * 更新のタイミング
   * 1. Bookデータが差し替わった場合 (データ送信時を含む)
   *
   * watch 内で初期化処理を行うのでここでの初期値は適当。
   **/
  const hasPassword = ref(book.value.bookPass !== null && book.value.bookPass !== '')

  /**
   * ロックが解除されているか否か
   *
   * 更新のタイミング
   * 1. Bookデータが差し替わった場合
   * 2. unlockに成功した場合
   *
   * watch 内で初期化処理を行うのでここでの初期値は適当。
   **/
  const isUnlocked = ref(bookStore.isUnlocked(book.value.bookHash) || !hasPassword.value)

  /** ロック解除のフォーム */
  const lockForm = reactive({ password: '' })

  /** ロックを解除する */
  function unlock() {
    if (book.value.bookPass === md5(lockForm.password)) {
      bookStore.unlock(book.value.bookHash)
      isUnlocked.value = true
    } else {
      swalError.fire({ text: 'パスワードが違います。' })
    }
  }

  watch(
    book,
    () => {
      hasPassword.value = book.value.bookPass !== null && book.value.bookPass !== ''
      isUnlocked.value = bookStore.isUnlocked(book.value.bookHash) || !hasPassword.value
    },
    { immediate: true },
  )

  return { hasPassword, isUnlocked, lockForm, unlock }
}
